import { Injectable } from "@angular/core";
import { CookiesService } from "./cookies.service";
import { ApiService } from "./api.service";
import { environment } from '../../environments/environment';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {map} from "rxjs/operators";

export interface IUserInfo {
  username?: string;
  thumbprint?: string;
  organization?: string;
  timezoneUser?: string;
  timezoneUserOffsetMsk?: string;
}

@Injectable()
export class AuthService {

    public inactivity_logout: boolean = false;
    userInfo$: BehaviorSubject<IUserInfo> = new BehaviorSubject(null);

    constructor(
        private cookies: CookiesService,
		private api: ApiService
    ) {}

    get_token() {
        return this.cookies.get('auth_token');
    }

    get_cross_token() {
        return this.cookies.get('token');
    }

    log_in(login: any, pass: any) {
        return this.api.post('auth/login', {"login": login, "pass": pass});
    }

    log_in_by_signature(signature: string) {
        return this.api.post('auth/login', {"signature": signature});
    }

	logout() {
        this.cookies.delete('token');
        this.cookies.delete('auth_token');
        this.cookies.delete('check_token');
    }

    local_logout() {
        this.cookies.delete('auth_token');
        this.cookies.delete('check_token');
    }

    set_token(token: string) {
        this.cookies.set('auth_token', token);
    }

    set_check_token(token: string) {
        this.cookies.set('check_token', token);
    }

    get_check_token() {
        return this.cookies.get('check_token');
    }

    check_tokens() {
        return this.get_cross_token() == this.get_check_token();
    }

	isLogin() {
        return this.get_token().length;
	}

	get_user_data() {
		return this.api.post('auth/user', {}).pipe(map(res => {
		  this.userInfo$.next(res);
		  return res;
    }));
	}

	get_user_cert() {
        return this.api.post('auth/cert', {});
    }

	make_cross_log_in(cross_token)
    {
        return this.api.post('auth/cross-login', {'cross_token': cross_token});
    }

    set_certificate(certificateSN : string, issuerDN : string)
    {
        this.cookies.set('certificateSN', certificateSN);
        this.cookies.set('issuerDN', issuerDN);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts